import { createContext, useContext } from "react";

import type { ConnectionNotice, ConnectionState } from "./connection-status";

export type ConnectionContextValue = {
  state: ConnectionState;
  notice: ConnectionNotice;
  /**
   * The only way `reachability` ever changes. Feature code calls this from the
   * real outcome of a real request, so the banner can never claim BurgePOS is
   * reachable on the strength of `navigator.onLine` alone.
   */
  reportApiOutcome: (outcome: "succeeded" | "failed") => void;
};

export const ConnectionContext = createContext<ConnectionContextValue | null>(null);

export function useConnectionStatus(): ConnectionContextValue {
  const context = useContext(ConnectionContext);
  if (!context) {
    throw new Error("useConnectionStatus must be used within ConnectionStatusProvider.");
  }
  return context;
}
